import * as Yup from 'yup';
import { Menu } from '@/types/menus';
import { MediaManager } from '@/components';
import InputText from '@/components/InputText';
import { useFormikContext } from 'formik';
import { getThumbnailImage } from '@/utils/media';
import { useParams } from 'react-router-dom';
import { Stack, Paper, Typography, FormControlLabel, Switch } from "@mui/material";

const MenuDetailsTab = () => {
  const { organizationId } = useParams<{ organizationId: string }>()
  const { values, handleChange, errors, setFieldValue } = useFormikContext<Menu>();

  return (
    <Stack gap={2}>
      <Paper sx={{ padding: 2 }}>
        <Typography variant="h4">Detalles</Typography>
        <InputText label="Nombre" margin="normal" name="title" size="small" editMode={true} />
        <InputText label="Descripción" margin="dense" name="description" size="small" multiline rows={3} editMode={true} />
        <InputText label="Orden" margin="dense" name="order" size="small" type="number" editMode={true} />
      </Paper>
      <Paper sx={{ padding: 2 }}>
        <Stack gap={2}>
          <Typography variant="h4">Foto de portada</Typography>
          <MediaManager
            value={getThumbnailImage({ file: values?.image, organizationId })}
            onChange={(value: Menu['image']) => {
              setFieldValue('image', value[0]);
            }}
            helperText={errors?.image as string | undefined}
          />
        </Stack>
      </Paper>

      <Paper sx={{ padding: 2 }}>
        <Stack gap={2}>
          <Typography variant="h4">Estado</Typography>
          <Stack>
            <FormControlLabel
              label="Publicado"
              labelPlacement="start"
              sx={{
                margin: 0,
                display: "flex",
                justifyContent: "space-between",
              }}
              control={<Switch name="isPublished" checked={values.isPublished} onChange={handleChange} />}
            />
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default MenuDetailsTab;

export const MenuDetailsSchema = Yup.object().shape({
  title: Yup.string().min(3, "Muy corto, ingresa al menos 3 caracteres").max(50, "Muy largo, máximo 150 caracteres").required("Campo requerido"),
  description: Yup.string().min(15, "Muy corto, ingresa al menos 50 caracteres").max(150, "Muy largo, máximo 150 caracteres").required("Campo requerido"),
  organization: Yup.string(),
  flow: Yup.array().of(Yup.string()),
  isPublished: Yup.boolean(),
});
